// posthog.client.ts
import { useUser } from '@clerk/clerk-react';
import posthog from 'posthog-js';
import { useEffect } from 'react';

const isProd = process.env.NODE_ENV === 'production';

function initPostHog() {
  if (!isProd) return;
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY!, {
    api_host: 'https://eu.i.posthog.com',
  });
}

const PosthogProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useUser();
  useEffect(() => {
    initPostHog();
  }, []);

  useEffect(() => {
    if (posthog.__loaded && user) {
      posthog.identify(user.id, {
        email: user.emailAddresses[0].emailAddress,
      });
    }
  }, [user]);

  return <>{children}</>;
};

export default PosthogProvider;
